module.exports = __webpack_public_path__ + "videos/mts-products-chats-one-click-call.2b407d3.mp4";